import React, { useContext, useEffect, useState } from "react";
import { useSearchParams } from "react-router";
import { createUseStyles } from "react-jss";
import { EmpdContext } from "../../Context";
import { useMsal } from '@azure/msal-react'
import ProviderDashboardNavigationBar from "./DashboardNavigationBar";
import WelcomeBanner from "./WelcomeBanner";
import DashboardCard from "./DashboardCard";
import ContentWrapper from "..//ContentWrapper";
import AnnouncementsCard from "./AnnouncementsCard";
import UserData from "../../Interfaces/UserData";
import { cloneDeep } from "lodash";
import { RotatingLines } from 'react-loader-spinner';
import DashboardHeader from './DashboardHeader';
import WelcomeModal from '../WelcomeModal';
import DeclinedModal from '../DeclinedModal';
import NotAuthorized from '../NotAuthorized';
import { isProvider } from '../../utils';

const useStyles = createUseStyles({
  root: {},
  dashboardWrapper: {
    background: "#f8f8f8",
    height: "100%",
    padding: "50px 0px",
  },
  dashboardContent: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "top",
  },
  dashboardCard: {
    flexBasis: "44.5%",
  },
  icon: {
    width: 30,
    height: "auto",
    marginRight: 10,
  },
  announcementHeading: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
});

const useMyContext = () => {
    const context = useContext(EmpdContext)
    if( !context ) {
        throw new Error("No provider found for Context")
    }
    return context
}

const ProviderResources = () => {
  const context = useMyContext()
  const { isLoading, isPatientLoading, authUser, setAuthUser, isResearchParticipant, setIsResearchParticipant, updateFields, setUpdateFields, writeFlags, userData, setUserData, fetchPatientData, envelope, setEnvelope, getCookie, activeSession, setActiveSession, login, pdfDoc, setPdfDoc, addNewUser, fetchNonParticipantData, patientResult, sign, setActiveMrn, isUsPerson, schemaName, demoTable, fetchNamespace, conditionSet, userCreated, fetchProfile, user } = context
  const [declined, setDeclined] = useState<boolean>(false)
  const [searchParams, setSearchParams] = useSearchParams()

  const { instance: msalInstance } = useMsal()
  const classes = useStyles()

  const activeAccount = msalInstance.getActiveAccount()

  useEffect(() => {
    if( !activeAccount ) {
      msalInstance.loginRedirect({
                authority: "https://globalempd.b2clogin.com/globalempd.onmicrosoft.com/B2C_1_EMPD_PROVIDER",
                state: `${window.location.origin}/provider/resources`,
                scopes: ['profile','openid'],
            })

    }
    fetchProfile('provider/dashboard')
  }, [])

  const render = () => {
   if( !activeAccount ) {
      return (
        <>
          You will be redirected to log in in a moment
        </>
      )
    }

    if( !isLoading && !isProvider(user) ) {
      return <NotAuthorized />
    }

	return ( 
		<div>
			<DashboardHeader />
			<div className={classes.dashboardWrapper}>
		  		<DashboardCard title={'Resources'} className={classes.dashboardCard}>
	    		    <div className={classes.dashboardWrapper}>
    	        		<ContentWrapper>
		        	        <div className={classes.dashboardContent}>
        		    	        Additional resources and educational materials will be available here soon.
                			</div>
			            </ContentWrapper>
    			    </div>
				</DashboardCard>
			</div>
		</div>
	)
  }

  sessionStorage.setItem('post-login-redirect-url',  `${window.location.origin}/providers/resources`);

  return (
  	<EmpdContext.Consumer>
		{() => render() }
	</EmpdContext.Consumer>
  )
};

export default ProviderResources;
